"use client";

import { ReactNode } from "react";
import NextForm from "next/form";
import { GridRowId } from "@mui/x-data-grid-pro";
import { useCampaignDialogs } from "../Providers/CampaignDialogsContext";
import { useEditDialog } from "../Providers/EditDialogContext";
import { updateCampaignAction } from "../actions";

interface FormProps {
  children: ReactNode;
}

export default function Form({ children }: FormProps) {
  const { setRowSelectionModel } = useCampaignDialogs();
  const { campaignIdToEdit, closeEditDialog } = useEditDialog();

  const handleAction = async (formData: FormData) => {
    const result = await updateCampaignAction(formData);
    if (result.success) {
      closeEditDialog();
      setRowSelectionModel({
        ids: new Set<GridRowId>([]),
        type: "include",
      });
    } else {
      console.error("Error updating campaign:", result.error);
    }
  };

  return (
    <NextForm action={handleAction}>
      {campaignIdToEdit && (
        <input type="hidden" name="id" value={campaignIdToEdit} />
      )}
      {children}
    </NextForm>
  );
}
